module.exports = __webpack_public_path__ + "img/icon-external-link.77a1dd38.svg";